import type { ILocationAddress } from "@chaosinsight/postoffice-portalclient"

export class LocationAddress {
	public country: string
	public state: string
	public city: string
	public zipCode: string
	public street: string
	public latitude: number
	public longitude: number

	constructor(
		country: string,
		state: string,
		city: string,
		zipCode: string,
		street: string,
		latitude: number,
		longitude: number
	) {
		this.country = country
		this.state = state
		this.city = city
		this.zipCode = zipCode
		this.street = street
		this.latitude = latitude
		this.longitude = longitude
	}

	public toApi(): ILocationAddress {
		return {
			Country: this.country,
			State: this.state,
			City: this.city,
			ZipCode: this.zipCode,
			Street: this.street,
			Latitude: this.latitude,
			Longitude: this.longitude,
		}
	}

	public static fromApi(data: ILocationAddress | null): LocationAddress | null {
		return data !== null
			? new LocationAddress(
				data.Country,
				data.State,
				data.City,
				data.ZipCode,
				data.Street,
				data.Latitude,
				data.Longitude)
			: null
	}
}
